module.exports = __webpack_public_path__ + "fonts/Play-Exchange-Icons.017b0e6.eot";